import { useEffect, useState } from 'react';

import useServerSideRendering from '@hooks/useServerSideRendering';

const usePrefersReducedMotion = () => {
  const isHydrated = useServerSideRendering();
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    if (isHydrated) {
      const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
      setPrefersReducedMotion(mq.matches);
      const onChange = () => setPrefersReducedMotion(mq.matches);
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    }
  }, [isHydrated]);

  return prefersReducedMotion;
};

export default usePrefersReducedMotion;
